import React from 'react';
import { Card, Title, Space, Text } from '@mantine/core';
import { BookingPreview } from '../BookingPreview';
import { JoinCallButton } from '../JoinCallButton';
import { ProfileButton } from '../ProfileButton';
import { BookingResponseModel } from '../../../../../types/BookingModels';
import { primaryColor } from '../../../../../constants/theme';

interface SingleBookingHeaderCardProps {
  bookingType: 'incoming' | 'outgoing';
  booking: BookingResponseModel;
  profileId: string;
  groupedBookings: BookingResponseModel[];
}

export const SingleBookingHeaderCard = ({
  bookingType,
  booking,
  profileId,
  groupedBookings,
}: SingleBookingHeaderCardProps) => {
  return (
    <Card maw={600} mx='auto' shadow='none' withBorder data-testid="single-booking-header-card">
      <Title order={4} c={primaryColor} ta='center' data-testid="single-booking-header-title">
        {bookingType === 'outgoing' ? 'Outgoing Conversation' : 'Incoming Conversation'}
      </Title>
      <Space h='md' />
      <BookingPreview
        booking={booking}
        profileId={profileId}
        groupedBookings={groupedBookings}
        hideProfileButton
      />
      <Space h='md' />
      <Text ta="center" c="dimmed" size="sm">
        {groupedBookings.length} booking{groupedBookings.length === 1 ? '' : 's'}
      </Text>
      <Space h='md' />
      <JoinCallButton groupedBookings={groupedBookings} alwaysShow fullWidth />
      <Space h='sm' />
      <ProfileButton
        userId={bookingType === 'outgoing' ? booking.professionalId : booking.userId}
        bookingId={booking.id}
        width="100%"
        overrideText="View Profile"
      />
    </Card>
  );
};
